export var IdPersistence;
(function (IdPersistence) {
    IdPersistence["BlogVersion"] = "blogVersion";
    IdPersistence["LastProduction"] = "lastProduction";
    IdPersistence["LastBooster"] = "lastBooster";
    IdPersistence["LastRankingUpdate"] = "lastRankingUpdate";
    IdPersistence["ContractData"] = "contractData";
    IdPersistence["Tracking"] = "tracking";
    IdPersistence["QuestIntro"] = "questIntroIds";
    IdPersistence["Credentials"] = "credentials";
    IdPersistence["TestCredentials"] = "testCredentials";
    IdPersistence["Settings"] = "settings";
    IdPersistence["Version"] = "version";
    IdPersistence["FbConnected"] = "fbConnected";
    IdPersistence["Doghouse"] = "doghouse";
    IdPersistence["Tutorial"] = "tutorial";
    IdPersistence["Logging"] = "logging";
    IdPersistence["TournamentInfo"] = "tournamentInfo";
    IdPersistence["AnimationSettings"] = "animationSettings";
    IdPersistence["LastWebOnlyOfferNotification"] = "lastWebOnlyOfferNotification";
    // shared with mobile
    IdPersistence["CoopPreviousLevel"] = "coopPreviousLevel";
    IdPersistence["CoopPreviousRanking"] = "coopPreviousRanking";
    IdPersistence["PlayerLeaguePreviousRanking"] = "playerLeaguePreviousRanking";
    IdPersistence["ClickedGrowthOffers"] = "clickedGrowthOffers";
})(IdPersistence || (IdPersistence = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/IdPersistence.ts
// module id = 39
// module chunks = 3